<template>
  <b-row>
    <b-col lg="3" md="3" sm="8" cols="8" class="pe-0">
      <div class="mt-5">
        <span class="p-input-icon-left my-3 card-search mt-4">
          <i class="pi pi-search" />
          <InputText v-model="SearchValue.inputValue" @keyup="$emit('search', SearchValue.inputValue)"
            :placeholder="placeholder" />
        </span>
      </div>
    </b-col>
    <b-col lg="1" md="1" sm="2" cols="2">
      <div style="margin-top:18px;">
        <slot name="tablefilter"></slot>
      </div>
    </b-col>
    <b-col lg="1" md="1" sm="2" cols="2" class="px-0">
      <div style="margin:18px 0 0 0;">
        <slot name="exceldownload"></slot>
      </div>
    </b-col>
    <!-- <b-col lg="3" md="3" sm="6" cols="6">
        <div class="mt-1">
          <span class="field mb-0 ms-3 mt-1">
            <Datepicker
              class="date"
              placeholder="From Date"
              label=""
              name=""
              id=""
              v-model="SearchValue.fromdate"
              @date-select="
                $emit('dateSearch', SearchValue.fromdate, SearchValue.todate)
              "
              @clear-click="
                $emit('dateSearch', SearchValue.fromdate, SearchValue.todate)
              "
              :showButtonBar="true"
            />
          </span>
        </div>
      </b-col>
      <b-col lg="3" md="3" sm="6" cols="6">
        <div class="mt-1">
          <span class="field mb-0 ms-3 mt-1">
            <Datepicker
              class="date"
              placeholder="To date"
              label=""
              name=""
              id=""
              v-model="SearchValue.todate"
              @date-select="
                $emit('dateSearch', SearchValue.fromdate, SearchValue.todate)
              "
              @clear-click="
                $emit('dateSearch', SearchValue.fromdate, SearchValue.todate)
              "
              :showButtonBar="true"
            />
          </span>
        </div>
      </b-col> -->

  </b-row>
  <b-row>
    <b-col lg="12" md="12" sm="12" cols="12" v-if="AddNewHideAndShow">
      <div class="mobilesearch float-end" style="margin:15px 10px 0 0 ;">
        <AddButton :btnname="$t('btn.plusaddnew')" @click="$emit('IsAdd')" />
      </div>
    </b-col>
  </b-row>
  <div>
    <slot name="mobilecard"></slot>
  </div>
  <div class="d-flex justify-content-center">
    <b-pagination v-model="state.currentPage" :total-rows="totalRecords" :per-page="perPage"
      :rows-per-page="state1.pageSize"></b-pagination>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, reactive } from "vue";
import TextField from "./TextInput.vue";
import Datepicker from "./DatePicker.vue";

export default defineComponent({
  components: {
    TextField,
    Datepicker,
  },

  props: {
    placeholder: {
      type: String,
      default: "Keyword Search",
    },
    AddNewHideAndShow: {
      type: Boolean,
      default: true,
    },
    state: {
      type: Object,
      default: {},
    },
    totalRecords: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 5,
    },
  },

  setup(props, { emit }) {
    let SearchValue = ref({
      inputValue: "",
      fromdate: "",
      todate: "",
    });
    const state1 = ref({
      currentPage: 1, // current page number
      pageSize: 5, // number of rows per page
      totalRows: 0,
      rowsCount: 0, // total number of rows in the database
      mobilepageSize: 5,
    });
    // const totalPages = Math.ceil(totalRecords / state1.pageSize);


    return {
      SearchValue,
      state1,
    };
  },
});
</script>


<style lang="scss">
.mobilesearch .addbtn {
  border: none !important;
  padding: 0.5rem 0.75rem !important;
  font-size: 12px;
  white-space: nowrap;
  justify-content: end;
  margin-top: 3px;
}

@media only screen and (max-width: 425px) {
  .table-search {
    width: 100% !important;
  }
}
</style>
